import { size, theme } from "@/config/theme";
import styled from "styled-components";
import { breakpoints } from "@/utils/breakpoint";

export const SCContainerDisplayRow = styled.div`
    display: flex;
    flex-direction: row;
`;

export const SCContainerDisplayColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SCContainerContent = styled.div`
    // max-width: ${size.px.l}px;
    max-width: ${size.px.m}px;
    width: 100%;
    padding: 0 ${theme["spacing-lxl"]};

    // Reduce side padding on tablets/phones so content isn't cramped
    ${breakpoints(
        "padding",
        "",
        [{ [size.px.xs]: `0 ${theme["spacing-ml"]}` }],
        "max-width"
    )};
`;

export const SCButton = styled.button.attrs<{ as?: React.ElementType }>(
    (props) => ({
        as: props.as || "button"
    })
)`
    padding: 8px 15px;
    border-radius: ${theme["border-radius"]};
    text-decoration: none;
    display: inline-block;
    text-align: center;
    border: none;
    cursor: pointer;

    &:hover {
        cursor: pointer;
    }
`;

export const SCEmptyStyleButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    text-align: inherit;
    outline: none;
    cursor: pointer; // Change this if you want a pointer cursor

    /* Remove button-specific properties */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    /* Remove any user agent styles */
    display: inline;
    width: auto;
    height: auto;
    box-shadow: none;

    /* Optional for ensuring no focus styles */
    &:focus {
        outline: none;
        box-shadow: none;
    }

    &:hover,
    &:active,
    &:focus-visible {
        outline: none;
        background: none;
        box-shadow: none;
    }
`;

// This to replace the above.
export const SCNoStyleButton = styled.button`
    // Removes button default styling
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
`;
